module.exports = __webpack_public_path__ + "img/service-digital-3.c0b10cbe.png";